import styled from "@emotion/styled";
const Container = styled.div`
  font-size: ${(props) => props.fontSize || "15px"};
  color: ${(props) => props.color || "black"};
`;

const MUIButtonrt = {
  textTransform: "capitalize",
};

const forprofile = styled.div`
  flex-direction: column;
  display: flex;
`;
const LeftButton = styled.div`
  margin-right: 4px;
  font-size: 5px;
`;
const RightButton = styled.div`
  font-size: 0px;
`;
const Subcaption = styled.div`
  font-size: 10px;
  text-align: right;
`;

const SC = {
  Container,
  forprofile,
  MUIButtonrt,
  LeftButton,
  RightButton,
  Subcaption,
};

export default SC;
